import { jsx as _jsx } from "react/jsx-runtime";
import EmbeddedDetection from '../icons/EmbeddedDetection';
import FullDetection from '../icons/FullDetection';
const DetectionIcon = ({ is_embedded }) => {
    switch (is_embedded) {
        case true:
            return _jsx(EmbeddedDetection, {});
        case false:
            return _jsx(FullDetection, {});
        default:
            return null;
    }
};
export default DetectionIcon;
